import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    transition: 'position .1s cubic-bezier(0, 0, 0.2, 1)',
    zIndex: 1000,

    '&.card--container__one .card-item': {
      minHeight: 104,
      flexDirection: 'row',

      '& .card--title__group': {
        marginBottom: 0,
      },

      '& .card--main__statistics': {
        alignItems: 'center',
        alignSelf: 'center',
        marginLeft: 32,
      },

      '& .card--main__weekly-bookings': {
        marginLeft: 70,
      },
    },

    '&.card--container__two .card-item': {
      minHeight: 173,
      flexDirection: 'column',

      '& .card--main__statistics': {
        alignSelf: 'center',
      },

      '& .card--main__weekly-bookings': {
        marginLeft: 70,
      },
    },

    '&.card--container__three .card-item': {
      minHeight: 193,
      flexDirection: 'column',

      '& .card--main__statistics': {
        alignSelf: 'center',
      },

      '& .card--main__weekly-bookings': {
        marginLeft: 70,
      },
    },
  },
  card: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'space-between',
    flex: 1,
    borderRadius: theme.borderRadius.min,
    padding: '16px 24px 24px 22px',
    backgroundColor: theme.colors.gray1,
    boxShadow: '0px 2px 8px rgba(56, 178, 166, 0.16)',

    '&:not(:last-child)': {
      marginRight: 24,
    },

    '&:before': {
      position: 'absolute',
      content: "''",
      top: 0,
      left: 0,
      bottom: 0,
      width: 6,
      borderRadius: '2px 0 0 2px',
    },
  },
  cardLink: {
    marginLeft: 6,
    verticalAlign: 'middle',
    cursor: 'pointer',
    fill: 'rgba(0, 0, 0, .85)',

    '&:hover': {
      fill: '#38B2A6',
    },
  },
  cardTitleGroup: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: 16,

    '& h4': {
      ...theme.typography.h4,
      color: theme.colors.titleColor,
      marginBottom: 8,
    },

    '& p': {
      fontSize: 12,
      lineHeight: '20px',
      userSelect: 'all',
      marginBottom: 0,
      color: theme.colors.captionColor,
    },
  },
  cardMainStatistics: {
    display: 'flex',
    justifyContent: 'space-around',

    '& .card--main__weekly-bookings, & .card--main__total-bookings': {
      textAlign: 'center',
    },

    '& .card--main__weekly-bookings p:before': {
      content: "''",
      position: 'absolute',
      left: -14,
      top: '50%',
      width: 6,
      height: 6,
      marginTop: -3,
      backgroundColor: '#F9A600',
      borderRadius: '100%',
    },

    '& h1': {
      display: 'inline-block',
      margin: 0,
      ...theme.typography.h1,
    },

    '& p': {
      position: 'relative',
      ...theme.typography.body4,
      color: theme.colors.captionColor,
      margin: 0,
      userSelect: 'all',
      whiteSpace: 'nowrap',
    },

    '& span': {
      paddingLeft: 4,
      fontSize: 12,
      lineHeight: '20px',
      color: theme.colors.captionColor,
    },
  },
  manualCard: {
    '&:before': {
      backgroundColor: '#F9A600',
    },
  },
  automationCard: {
    '&:before': {
      backgroundColor: '#3BC56F',
    },
  },
  herculesCard: {
    '&:before': {
      backgroundColor: '#6B92F3',
    },
  },
}));

export default useStyles;
